import {
  Button,
  Card,
  FormattedMessageDiv,
  InstantFundingLogo,
  GreenCheckWithText, LoadingCard,
} from '@odmonorepo/core-components';
import { Stack, Row, FormCheck, Col, Alert } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import {useEffect, useState} from 'react';
import { useNavigate } from '@tanstack/react-router';
import { getInstantFundingTermsAndConditions, postTermsAndConditions, postSession } from 'merchant-api/spiceroad';

export function IFLandingCard({
  onContinue,
  setAuthorizedUrl,
  registrationError,
  setRegistrationError,
}: {
  onContinue: () => void;
  setAuthorizedUrl: any;
  registrationError: any;
  setRegistrationError: (error: boolean) => void;
}) {
  const [validCheckbox1, setValidCheckbox1] = useState(false);
  const [validCheckbox2, setValidCheckbox2] = useState(false);
  const [termsAndConditionsLoaded, setTermsAndConditionsLoaded] = useState(false);
  const navigate = useNavigate();
  const { triggerSessionDetails, isSessionLoading, isSessionError } = postSession();
  const { termsAndConditionsText, isLoading, isError } = getInstantFundingTermsAndConditions();
  const [termsAndConditionsParagraphs, setTermsAndConditionsParagraphs] = useState<string[]>();
  const { sendTermsAndConditions, isLoadingSendTerms, isSendTermsAndConditionsError } = postTermsAndConditions();

  useEffect(() => {
    if(termsAndConditionsText !== undefined) {
      setTermsAndConditionsParagraphs(termsAndConditionsText.split("</p>").map((p: string) => p.replace('<p>', '')))
      setTermsAndConditionsLoaded(true);
    }
    if (isError) {
      setRegistrationError(true)
    }
  }, [termsAndConditionsText]);

  const handleSubmit = async () => {
    const sessionResult = await triggerSessionDetails();
    const saveTermsResult = sessionResult?.data?.authorized_url &&
      await sendTermsAndConditions({termsAndConditionsText: replaceNonIso88591Chars(termsAndConditionsText)});
    if (saveTermsResult?.termsAndConditionsAcceptedText) {
      setAuthorizedUrl(sessionResult.data.authorized_url);
      onContinue();
    } else setRegistrationError(true)
  };
  if (isLoading) return <LoadingCard/>;

  const replaceNonIso88591Chars = (str, replacementChar = '?') => {
    if (!str) {
      return "";
    }
    return str.replace(/[^\x00-\xFF]/g, replacementChar);
  }

  return (
    <Stack gap={5}>
      <Card>
        {registrationError && (
          <Alert variant="danger">
            <FormattedMessageDiv
              id="instantFunding.error"
              className="fs-6 fw-bold"
            />
            <FormattedMessage
              id="instantFunding.error.message"
              values={{
                tel: (txt: any) => {
                  return (
                    <a href={`tel:${txt}`} className="fw-bold">
                      {txt}
                    </a>
                  );
                },
              }}
            />
          </Alert>
        )}
        <Stack gap={3}>
          <FormattedMessageDiv
            id="instantFunding.tsAndCs.subtitle"
            className="h4 text-center"
          />
          <Stack>
            <FormattedMessageDiv
              id="instantFunding.tsAndCs.getFunds"
              className="fs-6"
            />
          </Stack>
          <Row>
            <Col xs={12} md={6}>
              <Stack gap={3}>
                <GreenCheckWithText
                  id="instantFunding.tsAndCs.fundsAccess"
                  className="fs-6"
                  gap={3}
                />
                <GreenCheckWithText
                  id="instantFunding.tsAndCs.immediate"
                  className="fs-6"
                  gap={3}
                />
                <GreenCheckWithText
                  id="instantFunding.tsAndCs.cost"
                  className="fs-6"
                  gap={3}
                />
              </Stack>
            </Col>
            <InstantFundingLogo className="d-none d-md-block me-auto col"></InstantFundingLogo>
          </Row>
        </Stack>
        <hr className='border-medium-gray' />
        <FormattedMessageDiv
          id="instantFunding.tsAndCs.heading"
          className="fw-bold fs-8"
        />
        <Stack gap={3} className="fs-8">
          <div>{termsAndConditionsParagraphs?.[0]}</div>
          <div>{termsAndConditionsParagraphs?.[1]}</div>
          <div>{termsAndConditionsParagraphs?.[2]}</div>
          <FormCheck
            className="fw-bold"
            style={{ minHeight: '0' }}
            id="disclosure1"
            label={
              <FormattedMessageDiv id="instantFunding.tsAndCs.disclosure1" />
            }
            onChange={() => setValidCheckbox1(!validCheckbox1)}
            checked={validCheckbox1}
          />
          <FormCheck
            className="fw-bold"
            id="disclosure2"
            label={
              <FormattedMessageDiv id="instantFunding.tsAndCs.disclosure2" />
            }
            onChange={() => setValidCheckbox2(!validCheckbox2)}
            checked={validCheckbox2}
          />
        </Stack>
      </Card>
      <Row className="justify-content-center text-center gx-5" xs={1} md={2}>
        <Button
          style={{ width: '260px' }}
          className="px-0 col mb-6 mx-2"
          variant="outline-primary"
          onClick={() => navigate({to: '/'})}
        >
          <FormattedMessage id="instantFunding.tsAndCs.cancel" />
        </Button>
        <Stack gap={2} style={{ maxWidth: '300px' }}>
          <Button
            disabled={!validCheckbox1 || !validCheckbox2 || !termsAndConditionsLoaded}
            className="px-0 col mx-2 border-0"
            loading={ isSessionLoading || isLoadingSendTerms }
            onClick={handleSubmit}
          >
            <FormattedMessage id="instantFunding.tsAndCs.continue" />
          </Button>
          <FormattedMessageDiv
            className="fs-8"
            id="instantFunding.tsAndCs.checkBoxesToContinue"
          />
        </Stack>
      </Row>
    </Stack>
  );
}
export default IFLandingCard;
